import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  summaryTitle: {
    id: 'instruct.openResponses.summary',
    defaultMessage: 'Summary',
    description: 'Title for the summary section in open responses'
  },
  totalUnits: {
    id: 'instruct.openResponses.label.totalUnits',
    defaultMessage: 'Total Units',
    description: 'Label for the total units in open responses'
  },
  totalAssessments: {
    id: 'instruct.openResponses.label.totalAssessments',
    defaultMessage: 'Total Assessments',
    description: 'Label for the total assessments in open responses'
  },
  totalResponses: {
    id: 'instruct.openResponses.label.totalResponses',
    defaultMessage: 'Total Responses',
    description: 'Label for the total responses'
  },
  training: {
    id: 'instruct.openResponses.label.training',
    defaultMessage: 'Training',
    description: 'Label for the training count'
  },
  peer: {
    id: 'instruct.openResponses.label.peer',
    defaultMessage: 'Peer',
    description: 'Label for the peer count'
  },
  self: {
    id: 'instruct.openResponses.label.self',
    defaultMessage: 'Self',
    description: 'Label for the self count'
  },
  waiting: {
    id: 'instruct.openResponses.label.waiting',
    defaultMessage: 'Waiting',
    description: 'Label for the waiting count'
  },
  staff: {
    id: 'instruct.openResponses.label.staff',
    defaultMessage: 'Staff',
    description: 'Label for the staff count'
  },
  finalGradeReceived: {
    id: 'instruct.openResponses.label.finalGradeReceived',
    defaultMessage: 'Final Grade Received',
    description: 'Label for the final grade received count'
  },
  details: {
    id: 'instruct.openResponses.title.details',
    defaultMessage: 'Details',
    description: 'Title for the details section in open responses'
  },
  unitName: {
    id: 'instruct.openResponses.table.header.unitName',
    defaultMessage: 'Unit Name',
    description: 'Label for the unit name header'
  },
  assessment: {
    id: 'instruct.openResponses.table.header.assessment',
    defaultMessage: 'Assessment',
    description: 'Label for the assessment header'
  },
  staffGrader: {
    id: 'instruct.openResponses.table.header.staffGrader',
    defaultMessage: 'Staff Grader',
    description: 'Label for the staff grader header'
  },
  viewAndGradeResponses: {
    id: 'instruct.openResponses.button.viewAndGradeResponses',
    defaultMessage: 'View and Grade Responses',
    description: 'Label for the link to view and grade responses'
  },
  noAssessmentsFoundMessage: {
    id: 'instruct.openResponses.noAssessmentsFoundMessage',
    defaultMessage: 'No assessments found.',
    description: 'Message displayed when no assessments are found in the details table'
  }
});

export default messages;
